<template>
  <div class="animated fadeIn">
    <b-row>
      <SubDivisionBacklog :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0"></SubDivisionBacklog>

      <SubDivisionDelivered :lgSize="6" :lgOffset="0" :locParam="1" :idCity="0"></SubDivisionDelivered>
    </b-row>
  </div>
</template>

<script>
import SubDivisionBacklog from "../../components/SubDivisionBacklog-Column";
import SubDivisionDelivered from "../../components/SubDivisionDelivered-Column";

import { Chart } from "highcharts-vue";

export default {
  name: "dashboard",
  components: {
    SubDivisionBacklog,
    SubDivisionDelivered,
    highcharts: Chart
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
